import { Link } from "react-router-dom";
import { useRecentlyViewed } from "@/hooks/useRecentlyViewed";

export default function RecentlyViewedStrip() {
  const { recentlyViewed, clearRecentlyViewed } = useRecentlyViewed();

  if (recentlyViewed.length === 0) return null;

  return (
    <div
      className="lg:hidden fixed left-0 right-0 z-39 bg-white border-t border-gray-100"
      style={{ bottom: "calc(env(safe-area-inset-bottom) + 64px)" }}
    >
      {/* Header row */}
      <div className="flex items-center justify-between px-3 pt-2 pb-1">
        <div className="flex items-center gap-1.5">
          <i className="ri-time-line text-xs" style={{ color: "#B8860B" }} />
          <span className="text-xs font-bold text-gray-700">Recently Viewed</span>
        </div>
        <button
          onClick={clearRecentlyViewed}
          className="text-xs text-gray-400 cursor-pointer active:text-gray-600 whitespace-nowrap"
        >
          Clear
        </button>
      </div>

      {/* Horizontal scroll strip */}
      <div className="flex gap-2.5 overflow-x-auto px-3 pb-2.5 scrollbar-hide" style={{ scrollbarWidth: "none" }}>
        {recentlyViewed.map((product) => {
          const discount = Math.round(
            ((product.originalPrice - product.price) / product.originalPrice) * 100
          );
          return (
            <Link
              key={product.id}
              to={`/product/${product.id}`}
              className="flex-shrink-0 flex items-center gap-2 bg-gray-50 rounded-xl px-2 py-1.5 active:scale-95 transition-transform cursor-pointer"
              style={{ minWidth: 160, maxWidth: 180 }}
            >
              {/* Thumbnail */}
              <div className="w-10 h-10 rounded-lg overflow-hidden bg-white flex-shrink-0 border border-gray-100">
                <img
                  src={product.image}
                  alt={product.title}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              {/* Info */}
              <div className="min-w-0 flex-1">
                <p className="text-xs font-semibold text-gray-800 leading-tight line-clamp-2 mb-0.5">
                  {product.title}
                </p>
                <div className="flex items-center gap-1">
                  <span className="text-xs font-extrabold" style={{ color: "#B8860B" }}>
                    ${product.price}
                  </span>
                  {discount > 0 && (
                    <span className="text-xs text-red-500 font-bold">-{discount}%</span>
                  )}
                </div>
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
